import { useAuth } from '@/contexts/AuthContext';
import { useAdmin } from '@/contexts/AdminContext';

/**
 * Admin-page gate using the same synchronous AdminContext values as Settings/nav.
 */
export function useAdminAccessGate() {
  const { user, serverUser, loading } = useAuth();
  const { isAdminMode, isAuthorizedAdmin, isAdminReady } = useAdmin();

  const isReady = !loading && isAdminReady && !!user && !!serverUser;

  return {
    isReady,
    isAuthorizedAdmin,
    isAdminModeEnabled: isAdminMode,
    hasAdminAccess: isReady && isAuthorizedAdmin && isAdminMode,
  };
}
